import React from 'react';
import { Col } from 'react-bootstrap';
import '../../includes/custom/css/footer.css';

const MainFooter = (props) => {
    return(
        <Col className="footer-base"></Col>
    );
};

export default MainFooter;